import { Button } from 'antd';
import apiCall from 'apps/catalog/apiCalls/market-indexes';
import {
  CreatePage,
  DetailPage,
  EditPage,
  ListPage,
} from 'common/ui/AdminCRUD/page';
import { Link } from 'react-router-dom';
import MarketIndexForm from './form';
import ItemDetail from './detail';
import { columnsGenerator } from './config';

export const MarketIndexListPage = (props, { params }) => (
  <ListPage
    enableSearch={true}
    title="Market Index"
    apiCall={apiCall}
    params={params}
    createUrl={`/catalog/market-index/create`}
    columnGenerator={props => columnsGenerator(props)}
    resourceName="data"
    {...props}
  />
);

export const MarketIndexDetailPage = props => (
  <DetailPage
    title="Market Index"
    apiCall={apiCall}
    listUrl={`/catalog/market-index`}
    ItemDetail={ItemDetail}
    resourceName="data"
    extraActions={id => (
      <>
        <Button type="primary">
          <Link to={`/catalog/market-index/${id}/edit`}>Edit</Link>
        </Button>
      </>
    )}
    {...props}
  />
);

export const MarketIndexEditPage = props => (
  <EditPage
    title="Market Index"
    apiCall={apiCall}
    listUrl={`/catalog/market-index`}
    ItemForm={MarketIndexForm}
    options={{ title: 'Edit Market Index' }}
    resourceName="data"
    {...props}
  />
);

export const MarketIndexCreatePage = props => (
  <CreatePage
    title="Market Index"
    apiCall={apiCall}
    listUrl={`/catalog/market-index`}
    ItemForm={MarketIndexForm}
    resourceName="data"
    {...props}
  />
);
